import classNames from "classnames"

import { ToastNotificationsBaseProps, ToastNotificationsIconProps } from "."
import TextButton from "../../../elements/V2/Buttons/TextButton"
import GatsbyStoryblokImage from "../../../elements/V2/GatsbyStoryblokImage"
import Typography from "../../../elements/V2/Typography"

import ArrowIcon from "@components/elements/V2/Icons/ArrowIcon"
import { getAccentColor } from "@utils/V2/color"
import React from "react"

type CountDownBannerProps = Omit<
  ToastNotificationsBaseProps & ToastNotificationsIconProps,
  "component"
>

const IconBanner = ({
  icon,
  text,
  mobileText,
  iconAlt,
  ctaText,
  ctaLink,
  ctaColor,
  textColor,
  textAlignment,
  backgroundColor,
  onClick,
}: CountDownBannerProps) => {
  textColor = textColor || getAccentColor(backgroundColor)

  return (
    <div
      className={classNames("flex w-full items-center gap-10", textAlignment)}
    >
      {!!icon && (
        <div className="flex h-24 min-w-24 items-center justify-center">
          <GatsbyStoryblokImage
            image={icon}
            height={24}
            aspectRatio="auto"
            alt={iconAlt || "Icon Banner"}
          />
        </div>
      )}
      <div className="inline-block">
        <Typography
          text={text}
          weight="book"
          font="grotesk"
          color={textColor}
          className="hidden pr-8 md:inline"
          size="body-sm-fixed"
        />
        <Typography
          text={mobileText || text}
          weight="book"
          font="grotesk"
          color={textColor}
          className="inline pr-8 md:hidden"
          size="body-sm-fixed"
        />
        <TextButton
          style="underlined"
          text={ctaText}
          linkUrl={ctaLink}
          textSize="body-sm-fixed"
          className="-mb-4 inline"
          color={ctaColor || textColor}
          icon={<ArrowIcon width="12px" height="9.3px" />}
          onClick={onClick}
        />
      </div>
    </div>
  )
}

export default IconBanner
